import { useMemo } from 'react';
import { getCapturedImageDisplayUrl } from '../services/s3/captureUrlService';

/**
 * Custom hook for getting captured image URLs from S3
 *
 * CHANGED 2026-05-30: Now uses direct public URLs instead of signed URLs
 * - Previous: Called Storage.get() async, returned signed URL with 1-hour expiration
 * - Current: Constructs public URL synchronously, never expires
 * - No loading state needed (instant URL construction)
 * - No API calls to S3
 *
 * @param {boolean} open - Whether dialog is open (for backward compatibility)
 * @param {string} capturedImageS3Key - S3 key or path from database
 * @returns {Object} Image URL and loading state (always false)
 */
export function useCapturedImage(open, capturedImageS3Key) {
  // Generate public URL synchronously (no async needed)
  const capturedImageSignedUrl = useMemo(() => {
    if (!capturedImageS3Key || !open) {
      return null;
    }
    return getCapturedImageDisplayUrl(capturedImageS3Key);
  }, [open, capturedImageS3Key]);

  // Loading is always false since public URLs are instant
  const loadingCapturedImage = false;

  return {
    capturedImageSignedUrl,
    loadingCapturedImage
  };
}
